import RolConfig from "./RolConfig";
import AuthService from "../auth/AuthService"
export default class UserService {
  /******* ROLES **********/
  static getRoles(app) {  
    return new Promise(async (resolve, reject) => {
      try{
        
        let token = await AuthService.getToken()
        let endpoint = RolConfig.endpointRoles;
        let response = await RolConfig.APIConnector.get(endpoint, {
            headers: { Authorization: "Bearer " + token, App:app },
        });
        console.log("getRoles", response, app)
        if(response.status==200){
          resolve(response.body)
        }else{
          reject(response)
        }
      }catch(e){
        reject(e)
      }
    });
  }
  
  /******** FIN ROLES *********/

}


// WEBPACK FOOTER //
// ./src/provider/rol/RolService.js